// Material UI
import { createMuiTheme } from "@material-ui/core/styles";
import BrandColors from "./BrandColors";

const { JLLBrandColors } = BrandColors;

const { Red } = JLLBrandColors;
export const theme = createMuiTheme({
  palette: {
    primary: {
      light: "#fff",
      main: Red.core,
      dark: "#000",
    },
    secondary: {
      main: "#afa8a7",
    },
  },
  overrides: {
    MuiInputBase: {
      root: {
        backgroundColor: "#fff",
      },
    },
    MuiOutlinedInput: {
      input: {
        padding: "10px 14px",
      },
      root: {
        height: "35px",
      },
    },
    MuiFormControl: {
      marginNormal: {
        marginTop: "5px",
      },
    },

    MuiButton: {
      containedPrimary: {
        "&:hover": {
          backgroundColor: "#E30613",
        },
      },
    },
    MuiTab: {
      root: {
        padding: "6px 15px",
        textTransform: "none",
        minWidth: 100,
      },
      wrapper: {
        alignItems: "baseline",
      },
    },
    MuiTableCell: {
      root: {
        padding: "0 5px 0 5px",
      },
      sizeSmall: {
        padding: "0 5px 0 5px",
      },
      body: {
        color: "rgba(0, 0, 0, 0.7)",
      },
    },
    MuiDrawer: {
      paper: {
        top: "54px",
      },
    },
    MuiTable: {
      root: {
        borderCollapse: "separate",
        "& td:first-child": {
          position: "sticky",
          left: 0,
          zIndex: "9",
          //backgroundColor: "#f9f9f9" Do not add BG color in global theme, it will affect the table all over the app.
        },
      },
    },
  },

  typography: {
    fontFamily: [
      "Source Sans Pro",
      "Source Sans Pro Regular",
      "Source Sans Pro Bold",
    ].join(","),
  },
});

export default theme;
